import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faShoppingCart, 
    faStore, 
    faExchangeAlt, 
    faEnvelope, 
    faMobileAlt, 
    faShieldAlt, 
    faUserCheck,
    faCar,
    faSearch,
    faCreditCard
} from '@fortawesome/free-solid-svg-icons';
import './HowItWorks.css';

const HowItWorks = () => {
    const [activeTab, setActiveTab] = useState('buyers'); // Default to buyers tab

    return (
        <section className="how-it-works-section">
            <div className="container">
                <h2>How It Works</h2>
                
                <div className="tab-switcher">
                    <button 
                        className={`tab-button ${activeTab === 'buyers' ? 'active' : ''}`}
                        onClick={() => setActiveTab('buyers')}
                    >
                        <FontAwesomeIcon icon={faShoppingCart} />
                        <span>For Buyers</span>
                    </button>
                    <button 
                        className={`tab-button ${activeTab === 'sellers' ? 'active' : ''}`}
                        onClick={() => setActiveTab('sellers')}
                    >
                        <FontAwesomeIcon icon={faStore} />
                        <span>For Sellers</span>
                    </button>
                </div>
                
                <div className="tab-content">
                    {activeTab === 'buyers' ? (
                        <div className="buyers-content">
                            <div className="process-steps">
                                <div className="step">
                                    <div className="step-number">1</div>
                                    <div className="step-icon">
                                        <FontAwesomeIcon icon={faUserCheck} />
                                    </div>
                                    <h3>Register an Account</h3>
                                    <p>Create your free account to get started with our secure platform.</p>
                                </div>
                                
                                <div className="step">
                                    <div className="step-number">2</div>
                                    <div className="step-icon">
                                        <FontAwesomeIcon icon={faCar} />
                                    </div>
                                    <h3>Tell Us What You're Looking For</h3>
                                    <p>Specify the details of what you want to buy, and we'll match you with verified sellers.</p>
                                </div>
                                
                                <div className="step">
                                    <div className="step-number">3</div>
                                    <div className="step-icon">
                                        <FontAwesomeIcon icon={faShieldAlt} />
                                    </div>
                                    <h3>Secure Communication</h3>
                                    <p>Our relay system protects your personal information while allowing seamless communication with sellers.</p>
                                </div>
                                
                                <div className="step">
                                    <div className="step-number">4</div>
                                    <div className="step-icon">
                                        <FontAwesomeIcon icon={faExchangeAlt} />
                                    </div>
                                    <h3>Complete Your Purchase</h3>
                                    <p>Finalize your transaction with confidence, knowing you're working with verified sellers.</p>
                                </div>
                            </div>
                            
                            <div className="cta-container">
                                <p>Ready to find exactly what you're looking for?</p>
                                <a href="/get-started" className="cta-button">Get Started as a Buyer</a>
                            </div>
                        </div>
                    ) : (
                        <div className="sellers-content">
                            <div className="process-steps">
                                <div className="step">
                                    <div className="step-number">1</div>
                                    <div className="step-icon">
                                        <FontAwesomeIcon icon={faUserCheck} />
                                    </div>
                                    <h3>Register an Account</h3>
                                    <p>Create your seller account to access our marketplace of verified buyers.</p>
                                </div>
                                
                                <div className="step">
                                    <div className="step-number">2</div>
                                    <div className="step-icon">
                                        <FontAwesomeIcon icon={faSearch} />
                                    </div>
                                    <h3>Filter Available Leads</h3>
                                    <p>Browse and filter leads to find buyers looking for exactly what you have to offer.</p>
                                </div>
                                
                                <div className="step">
                                    <div className="step-number">3</div>
                                    <div className="step-icon">
                                        <FontAwesomeIcon icon={faCreditCard} />
                                    </div>
                                    <h3>Purchase Leads</h3>
                                    <p>Purchase leads to unlock contact information and begin communication with interested buyers.</p>
                                </div>
                                
                                <div className="step">
                                    <div className="step-number">4</div>
                                    <div className="step-icon">
                                        <FontAwesomeIcon icon={faEnvelope} />
                                    </div>
                                    <h3>Secure Communication</h3>
                                    <p>Connect with buyers through our secure relay system to finalize transactions.</p>
                                </div>
                            </div>
                            
                            <div className="cta-container">
                                <p>Ready to connect with qualified buyers?</p>
                                <a href="/get-started" className="cta-button">Get Started as a Seller</a>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default HowItWorks; 